<template functional>
    <!--  
    -------  We use this component to support WCAG specifications, it is hidden at rendering ----
    -->
    <span class="a-hero-title">
        <h1>{{ $options.text }}</h1>
        <h2>{{ $options.text }}</h2>
    </span>
</template>

<script>
import store from "@/store";

export default {
    name: 'AHeroTitle',
    text: store.getters.getMapConfigProp('components.AHeroTitle.params')?.text,
}
</script>

<style lang="scss">
@import "a-hero-title";
</style>
